import CommentListContainer from './CommentListContainer';

export default CommentListContainer;
